var _mask, _path, _path2, _tspan, _path3, _tspan2, _path4, _tspan3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 83,
    viewBox: "0 0 390 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1002_45627",
    maskUnits: "userSpaceOnUse",
    x: 19.5,
    y: 10,
    width: 370,
    height: 45,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 19.5,
    y: 10,
    width: 370,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10H389.5V53H19.5V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.5 51H19.5V55H389.5V51Z",
    className: "id-contrast",
    mask: "url(#path-1-outside-1_1002_45627)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1002_45627)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16C20.5 12.6863 23.1863 10 26.5 10H136.5C139.814 10 142.5 12.6863 142.5 16V53H20.5V16Z",
    className: "component-foreground-id",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 63.4707,
    y: 35.598
  }, "TABB 1")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 16C143.5 12.6863 146.186 10 149.5 10H259.5C262.814 10 265.5 12.6863 265.5 16V53H143.5V16Z",
    className: "id-main"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 186.471,
    y: 35.598
  }, "TABB 1"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.5 16C266.5 12.6863 269.186 10 272.5 10H382.5C385.814 10 388.5 12.6863 388.5 16V53H266.5V16Z",
    className: "id-main"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 308.521,
    y: 35.598
  }, "TABB 3"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1002_45627",
    x: 0.5,
    y: 0,
    width: 162,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45627",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/tabs.d193d1c65fc6e892dda6ad74d0ff6072.svg";
export { ForwardRef as ReactComponent };